export default __webpack_public_path__ + "static/media/roll_cinamon.038bdd54.jpg";